import '@Partials/_ComStyles.scss';
import '@Partials/_SimpleStyles.scss';
import './BorderWhiteButtonV2.scss';

export default function BorderWhiteButtonV2(props){

    const className = 'button__borderWhiteButtonV2';

    return (
        <button onClick={props.onClick} className={className + (props.disabled ? '__disabled' : '') + ' width-wfa'} disabled={props.disabled}>
            {props.text}
        </button>
    );
}
